import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { authHeaders } from "../../utils/axios";

const BASE_URL = "users";

export const fetchAdminUsers = createAsyncThunk(
  "adminUsers/fetchAdminUsers",
  async (params, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(BASE_URL, {
        params,
        ...authHeaders(),
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const createAdminUser = createAsyncThunk(
  "adminUsers/createAdminUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(BASE_URL, data, authHeaders());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateAdminUser = createAsyncThunk(
  "adminUsers/updateAdminUser",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`${BASE_URL}/${id}`, data, authHeaders());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteAdminUser = createAsyncThunk(
  "adminUsers/deleteAdminUser",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`${BASE_URL}/${id}`, authHeaders());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const changeAdminPassword = createAsyncThunk(
  "adminUsers/changeAdminPassword",
  async ({ id, new_password }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`${BASE_URL}/${id}/change-password`, { new_password }, authHeaders());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const adminUserSlice = createSlice({
  name: "adminUsers",
  initialState: {
    users: [],
    pagination: {},
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminUsers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAdminUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.users = action.payload.data.data;
        state.pagination = action.payload.data.pagination;
      })
      .addCase(fetchAdminUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteAdminUser.fulfilled, (state, action) => {
        const index = state.users.findIndex((u) => u.id === action.meta.arg);
        if (index !== -1) {
          state.users[index].is_active = !state.users[index].is_active;
        }
      });
  },
});

export default adminUserSlice.reducer;
